export * from "./ActivitiesConfigurationDTO";
